import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

function TextAnimation() {
  // gsap.registerPlugin(SplitText, ScrollTrigger);

  // // Common animation configuration
  // const commonAnimationSettings = {
  //   opacity: 0,
  //   duration: 1,
  //   ease: "sine.out",
  //   stagger: 0.1,
  // };

  // // Text animations
  // gsap.utils.toArray(".animate-text, .animate-text p, .animate-text ul, .animate-text ol").forEach((item) => {
  //   const childSplit = new SplitText(item, {
  //     type: "lines,words,chars",
  //     linesClass: "split-child",
  //   });

  //   gsap.from(childSplit.lines, {
  //     ...commonAnimationSettings,
  //     scrollTrigger: {
  //       trigger: item,
  //       start: "top 85%",
  //     },
  //     y: 80,
  //   });
  // });

  // // Large text animations
  // gsap.utils.toArray(".animate-text-large").forEach((item) => {
  //   const childSplit = new SplitText(item, {
  //     type: "lines,words,chars",
  //     linesClass: "split-child",
  //   });

  //   const parentSplit = new SplitText(item, {
  //     linesClass: "split-parent",
  //   });

  //   gsap.from(childSplit.lines, {
  //     ...commonAnimationSettings,
  //     scrollTrigger: {
  //       trigger: item,
  //       start: "top 85%",
  //     },
  //     yPercent: 80,
  //   });
  // });

  // // Slide up animations
  // gsap.utils.toArray(".animate-slide-up").forEach((item) => {
  //   gsap.from(item, {
  //     ...commonAnimationSettings,
  //     scrollTrigger: {
  //       trigger: item,
  //       start: "top 85%",
  //     },
  //     y: 80,
  //   });
  // });

  // // Slide up animations
  // gsap.utils.toArray(".animate-slide-up-unit-info").forEach((item) => {
  //   gsap.from(item, {
  //     ...commonAnimationSettings,
  //     scrollTrigger: {
  //       trigger: item,
  //       start: "top 95%",
  //     },
  //     y: 80,
  //   });
  // });
}

export default TextAnimation;
